const FieldComponentTypes = require('./fieldComponentTypes');

const FieldTypeUtils = module.exports = {};

FieldTypeUtils.PRIMITIVE_TYPES = new Set(FieldComponentTypes.FIELD_COMPONENT_TYPES);

FieldTypeUtils.GROUPABLE_PRIMITIVE_TYPES = new Set([
    'CheckboxField',
    'DateField',
    'DateTimeField',
    'EmojiField',
    'FileField',
    'MultiSelectField',
    'SelectField',
    'SwitchField',
    'TextField'
]);

FieldTypeUtils.TEXT_FIELD_TYPES = new Set([
    'TextField',
    'TextareaField'
]);

FieldTypeUtils.SELECT_WITH_SPECIFY_TYPES = new Set([
    'SelectWithSpecifyField'
]);

FieldTypeUtils.normalizePrimitiveType = (type) => type;

FieldTypeUtils.isCanonicalPrimitiveType = (type) => FieldTypeUtils.PRIMITIVE_TYPES.has(type);

FieldTypeUtils.isPrimitiveType = (type) => FieldTypeUtils.isCanonicalPrimitiveType(type);

FieldTypeUtils.isGroupablePrimitiveType = (type) => FieldTypeUtils.GROUPABLE_PRIMITIVE_TYPES.has(
    FieldTypeUtils.normalizePrimitiveType(type)
);

FieldTypeUtils.isTextFieldType = (type) => FieldTypeUtils.TEXT_FIELD_TYPES.has(
    FieldTypeUtils.normalizePrimitiveType(type)
);

FieldTypeUtils.isSelectWithSpecifyType = (type) => FieldTypeUtils.SELECT_WITH_SPECIFY_TYPES.has(
    FieldTypeUtils.normalizePrimitiveType(type)
);
